// src/hooks/useServicesWeeklyCounts.js
import { useEffect, useMemo, useState } from "react";
import { fetchServicesWeeklyCounts } from "utils/api";

export function useServicesWeeklyCounts({ weekOf = null, includeCancelled = false } = {}) {
  const [data, setData] = useState(null);     // raw API result
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    let alive = true;
    setLoading(true);
    setError("");

    fetchServicesWeeklyCounts({
      week_of: weekOf,
      include_cancelled: includeCancelled,
    })
      .then((json) => {
        if (!alive) return;
        setData(json);
        setLoading(false);
      })
      .catch((err) => {
        if (!alive) return;
        setError(err?.message || "Failed to load weekly service counts");
        setLoading(false);
      });

    return () => { alive = false; };
  }, [weekOf, includeCancelled]);

  // Transform to ApexCharts series/categories
  const apex = useMemo(() => {
    if (!data) return { categories: [], series: [], meta: null };
    const categories = data.days || ["Mon","Tue","Wed","Thu","Fri","Sat","Sun"];
    const series = (data.series || []).map(s => ({
      name: s.service,
      data: s.data,
      // If you want stable colors per service name, compute color here.
    }));
    return {
      categories,
      series,
      meta: {
        week: data.week,
        dates: data.dates,
        totals: data.totals_per_day,
        total: data.grand_total,
        services: data.services,
      }
    };
  }, [data]);

  return { data, apex, loading, error };
}